import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useModalFormStore } from "../../store/modal-form-store";
import { ChangeLogDrawer } from "./atom.js";
import { Table } from "@renderbus/ui";
import { useChangeLog } from "./hooks/use-change-log";

export function UserChangeLogDrawer() {
  const t = getTranslateNsT("profile");
  const { openUserChangeLogDrawer, setOpenUserChangeLogDrawer } =
    useModalFormStore();
  const { columns, tableData } = useChangeLog();
  return (
    <ChangeLogDrawer
      width={700}
      open={openUserChangeLogDrawer}
      className="border-title log-drawer"
      title={t("user_chang_log_title")}
      onClose={() => {
        setOpenUserChangeLogDrawer(false);
      }}
      drawerContent={
        <div style={{ padding: "16px" }}>
          <Table
            columns={columns}
            dataSource={tableData}
            showPagination={false}
            className="transfer-operate"
            hidePaginationOnSinglePage={true}
            pagination={false}
          />
        </div>
      }
    />
  );
}
